module.exports = __webpack_public_path__ + "static/media/dre2.png.d150cf7f.jpg";